let colors = {};

export const getInitialColors = () => colors;
export const initializeColors = (newColors) => {
  colors = newColors;
};
